
import { defineComponent, computed, watch } from 'vue'
import { usePopupStore } from '@/store/popup'
import { usePacsStore } from '@/store/pacs'

export default defineComponent({
  setup() {
    const popupStore = usePopupStore()
    const uploadProgress = computed(() => usePacsStore().getUploadProgress)

    const closePopup = () => {
      popupStore.togglePopup('nowConnect', false)
    }
    
    return {
      closePopup,
      uploadProgress,
    }
  }
})
